

















import Vue from 'vue'
import {Action, Getter} from 'vuex-class'
import {Component, Prop} from 'vue-property-decorator'
import Modal from '../Modal.vue'
import { ModalSize } from '@/components/modal-size'
import Chat from './Chat.vue'

@Component<ChatModal>({
    components: {Chat, Modal}
})
export default class ChatModal extends Vue {
    @Getter public activeQuestionId
    @Prop(Function) public onCloseModal
    @Prop(Function) public replyCallBack

    public get modalSize() {
        return ModalSize
    }
}
